import { mapMutations, mapState } from 'vuex'
import { SET_SETTINGS_PROPERTY } from 'vx/mutations'

export default {
  computed: {
    ...mapState('settings', ['settings']),

    publicJobCutoff: {
      get () {
        return this.settings.public_job_cutoff
      },

      set (value) {
        this[SET_SETTINGS_PROPERTY]({ property: 'public_job_cutoff', value })
      }
    }
  },

  methods: {
    ...mapMutations('settings', [SET_SETTINGS_PROPERTY])
  }
}



// WEBPACK FOOTER //
// ./src/mixins/settings/state-mapper.js